module.exports = __webpack_public_path__ + "img/img-16.02cff0cb.webp";